import { useToast } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { createContext, useContext } from "react";
import memberService from "./member-service";

const MembershipContext = createContext(undefined);

const MembershipStateProvider = ({ children }) => {
   const toast = useToast();

   const loadMembershipLevels = async () => {
      try {
         const fetchResult = await memberService.getMembershipLevels();
         return fetchResult.data;
      } catch (error) {
         toast({ description: error.message, status: "error", title: "Membership Levels" });
      }
   };

   const { data: membershipLevels = [] } = useQuery({ queryKey: ["membershipLevels"], queryFn: loadMembershipLevels });

   return <MembershipContext.Provider value={{ membershipLevels }}>{children}</MembershipContext.Provider>;
};

const useMembership = () => {
   return useContext(MembershipContext);
};

export { MembershipStateProvider, useMembership };
